import { routeHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CookiePolicy from "@/pages/CookiePolicy";

export const Route = createFileRoute("/cookie-policy")({
  head: () => routeHead('Cookie Policy — AGAPE', 'Read how AGAPE uses cookies and manages your privacy preferences.', '/cookie-policy'),
  component: CookiePolicy,
});
